import React, { useContext, useEffect, useRef, useState } from 'react'
import FormDataContext from '../../../Contexts/FormData.context'
import { formActionEnum, jsonKeyMapping } from '../../../Config/Constants'
import Button from 'react-bootstrap/Button'
import { TemplateObject } from '../../../Models/TemplateObject'
import { useParams } from 'react-router-dom'
import InputWrapper from './InputWrapper'
import produce from 'immer'
import InputTextMask from './InputTextMask'
import AddMoreElements from './InputText/AddMoreElements'
import GroupElements from './InputText/GroupElements'
import AddMoreGroupElements from './InputText/AddMoreGroupElements'
import InputContext from '../../../Contexts/Input.Context'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment'
import { calculateListItem } from '../../../Util/calculationHelper'

type Props = {
    formElement: TemplateObject;
    handleInputChange:(e: HTMLInputElement, startsWith: string, startsWithKey:string, inputFieldSeparator:string, prefillInputVal:string) => void;
    onBlur: any,
    groups: any,
    fieldIndex: any
    handleDateChange: (id: string, type: string, date: any) => void;
};

const InputText = ({ formElement, handleInputChange, onBlur, groups, fieldIndex, handleDateChange }: Props) => {
    const { state, dispatch } = useContext(FormDataContext)
    const { setConditionalInput } = useContext(InputContext)
    const { formData } = state
    const [inputFields, setInputFields] = useState<TemplateObject>({})
    const [inputFieldGroup, setInputFieldGroup] = useState<TemplateObject>({})
    const [isMaxLimitReached, setMaxLimitReached] = useState<Boolean>(false)
    const datePickerRef = useRef<HTMLDivElement>(null);
    const [open, setOpen] = useState(false);

    const { stepName } = useParams()

    /* Load the dynamically added elements */
    useEffect(() => {
        const inputFields: TemplateObject = {}
        if (formElement[jsonKeyMapping.FORM_ADD_MORE] === 'yes') {
            const matchRegex = `${formElement[jsonKeyMapping.FORM_ID]}\\d`
            const re = new RegExp(matchRegex, 'g')
            const filterKeys = Object.keys(formData).filter((key) => key.match(re))

            filterKeys.forEach((id) => {
                if (typeof formData[id] === 'string') {
                    inputFields[id] = {
                        ...formElement,
                        [jsonKeyMapping.FORM_ID]: id,
                        [jsonKeyMapping.FORM_LABEL]: formElement[jsonKeyMapping.FORM_ADD_MORE_LABEL] || formElement[jsonKeyMapping.FORM_LABEL],
                        [jsonKeyMapping.FORM_ADD_MORE]: false,
                        [jsonKeyMapping.FORM_SUB_TOOLTIP]: null,
                        [jsonKeyMapping.TOTAL_CALCULATION]: null,
                        [jsonKeyMapping.SUB_TOTAL]: null,
                        [jsonKeyMapping.TOTAL_SUM]: null,
                        [jsonKeyMapping.CALCULATE_PERCENTAGE]: null,
                        [jsonKeyMapping.WITHOUT_DISCOUNT_TOTAL]: null,
                        [jsonKeyMapping.DISCOUNT]: null,
                        [jsonKeyMapping.FORM_LABEL_SUB]: null,
                        [jsonKeyMapping.FORM_SUBTEXT]: null,
                        [jsonKeyMapping.STARTSWITH]: null,
                        [jsonKeyMapping.ENDSWITH]: null,
                        [jsonKeyMapping.ISBOTHFIELDNONEMPTY]: null,
                        [jsonKeyMapping.INPUT_FIELD_SEPARATOR]: null,
                        [jsonKeyMapping.PRE_FILL_INPUT_VAL]: null,
                        isAddedDynamically: true
                    }
                }
            })
        }
        setInputFields(inputFields)

        /* max limit check */
        if (formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
            const dynamicFieldsListLength = Object.keys(inputFields).length
            if (dynamicFieldsListLength >= formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
                setMaxLimitReached(true)
            }
        }
        //console.log("formElement",formElement)
        /* For calculation */
        if (jsonKeyMapping.TOTAL_CALCULATION in formElement && formElement[jsonKeyMapping.TOTAL_CALCULATION] !== null || jsonKeyMapping.CALCULATE_PERCENTAGE in formElement &&
            formElement[jsonKeyMapping.CALCULATE_PERCENTAGE] !== null || jsonKeyMapping.WITHOUT_DISCOUNT_TOTAL in formElement &&
            formElement[jsonKeyMapping.WITHOUT_DISCOUNT_TOTAL] !== null || jsonKeyMapping.SUB_TOTAL in formElement &&
            formElement[jsonKeyMapping.SUB_TOTAL] !== null) {
            const key = `meta-data-${formElement[jsonKeyMapping.FORM_ID]}`
            let elIndex:any = ''
            let filteredObj:any = []
            let calculationModifiedId = formElement[jsonKeyMapping.TOTAL_CALCULATION]
            let subTotalModified = formElement[jsonKeyMapping.SUB_TOTAL]
            if(!!formData){
                Object.entries(formData).map(function ([k, v]) {
                    if(k.split("-")[0] === `${formElement[jsonKeyMapping.FORM_ID]}`.split("-")[0]){
                        filteredObj.push(k)
                    }
                })
               if(filteredObj.filter((x:any)=>x === `${formElement[jsonKeyMapping.FORM_ID]}`).length > 0){
                elIndex = `${formElement[jsonKeyMapping.FORM_ID]}`.split('-').length>1?`${formElement[jsonKeyMapping.FORM_ID]}`.split('-')[1]:''
               }
               if(!!formElement[jsonKeyMapping.TOTAL_CALCULATION]){
                    let calculateId = formElement[jsonKeyMapping.TOTAL_CALCULATION].split("|")
                    let modifiedId:any= [];
                    if(elIndex !== ''){
                        calculateId.map((itemId: TemplateObject) => {
                            modifiedId.push(`${itemId.split('-')[0]}-${elIndex}`)
                        })
                        calculationModifiedId = modifiedId.join("|")
                    }
               }
               if(!!formElement[jsonKeyMapping.SUB_TOTAL]){
                    if(elIndex !== ''){
                        subTotalModified = `${formElement[jsonKeyMapping.SUB_TOTAL].split('-')[0]}-${elIndex}`
                    }
               }
            }

           // console.log("elementIndex",calelementIndex)
            const metaData: TemplateObject = {
                calculationId: calculationModifiedId,
                subTotal: subTotalModified,
                totalSum: formElement[jsonKeyMapping.TOTAL_SUM],
                percentageId: formElement[jsonKeyMapping.CALCULATE_PERCENTAGE],
                withoutDiscountTotal: formElement[jsonKeyMapping.WITHOUT_DISCOUNT_TOTAL],
                discount: formElement[jsonKeyMapping.DISCOUNT],
                startsWith: formElement[jsonKeyMapping.STARTSWITH],
                endsWith: formElement[jsonKeyMapping.ENDSWITH],
                isBothFieldNonEmpty : formElement[jsonKeyMapping.ISBOTHFIELDNONEMPTY],
                inputFieldSeparator : formElement[jsonKeyMapping.INPUT_FIELD_SEPARATOR],
                prefillInputVal : formElement[jsonKeyMapping.PRE_FILL_INPUT_VAL]
            }
            const formElementData: TemplateObject = {
                [key]: metaData
            }
            if (formData[key]) {
                formElementData[key] = { ...formData[key], ...metaData }
            }
            dispatch({ type: formActionEnum.SET_FORM_DATA, payload: formElementData })
        }
        /* Add meta data information to render add more elements with separator */
        if (jsonKeyMapping.FORM_INPUT_SEPARATOR in formElement &&
            formElement[jsonKeyMapping.FORM_INPUT_SEPARATOR] !== null
        ) {
            const key = `meta-data-${formElement[jsonKeyMapping.FORM_ID]}`
            const metaData: TemplateObject = {
                // [jsonKeyMapping.FORM_ID]: formElement[jsonKeyMapping.FORM_ID],
                separatorId: formElement[jsonKeyMapping.FORM_ID],
                addMoreElement: true,
                separator: formElement[jsonKeyMapping.FORM_INPUT_SEPARATOR],
                startsWith: formElement[jsonKeyMapping.STARTSWITH] || ' ',
                endsWith: formElement[jsonKeyMapping.ENDSWITH] || ' ',
                isBothFieldNonEmpty: formElement[jsonKeyMapping.ISBOTHFIELDNONEMPTY] || ' ',
                inputFieldSeparator: formElement[jsonKeyMapping.INPUT_FIELD_SEPARATOR] || ' ',
                prefillInputVal : formElement[jsonKeyMapping.PRE_FILL_INPUT_VAL] || ' '
            }

            /* GROUP ELEMENTS */
            if (formElement[jsonKeyMapping.FORM_ADD_MORE_GROUP]) {
                metaData.children = formElement[jsonKeyMapping.FORM_GROUP_ELEMENT].map((input: TemplateObject) => input[jsonKeyMapping.FORM_ID])
                metaData.isGroupAdd = true
                metaData.groupInputSeparator = formElement[jsonKeyMapping.FORM_GROUP_INPUT_SEPARATOR] || ' '
                metaData.groupInputFormate = formElement[jsonKeyMapping.FORM_GROUP_INPUT_FORMATE] || ' '
                metaData.signatureFields = formElement[jsonKeyMapping.FORM_GROUP_SIGNATURE_FIELDS] || ' '
                metaData.subTotal = formElement[jsonKeyMapping.SUB_TOTAL] || ' '
                metaData.totalSum = formElement[jsonKeyMapping.TOTAL_SUM] || ' '
                metaData.labelsub = null
                metaData.subtext = null
                metaData.startsWith = formElement[jsonKeyMapping.STARTSWITH] || ' '
                metaData.endsWith = formElement[jsonKeyMapping.ENDSWITH] || ' '
                metaData.isBothFieldNonEmpty = formElement[jsonKeyMapping.ISBOTHFIELDNONEMPTY] || ' '
                metaData.inputFieldSeparator = formElement[jsonKeyMapping.INPUT_FIELD_SEPARATOR] || ' '
                metaData.discount = formElement[jsonKeyMapping.DISCOUNT] || ' '
                metaData.withoutDiscountTotal = formElement[jsonKeyMapping.WITHOUT_DISCOUNT_TOTAL] || ' '
                metaData.percentageId = formElement[jsonKeyMapping.CALCULATE_PERCENTAGE] || ' '
                metaData.calculationId = formElement[jsonKeyMapping.TOTAL_CALCULATION] || ' '
            }

            const formElementData: TemplateObject = {
                [key]: metaData
            }

            if (formData[key]) {
                formElementData[key] = { ...formData[key], ...metaData }
            }

            dispatch({ type: formActionEnum.SET_FORM_DATA, payload: formElementData })
        }

        return () => { }
    }, [stepName, formElement])

    /* Load the dynamically group elements */
    useEffect(() => {
        const inputFieldGroup: TemplateObject = {}
        const groupElementMetaKey = `meta-data-${formElement[jsonKeyMapping.FORM_ID]}`
        if (formElement[jsonKeyMapping.FORM_ADD_MORE_GROUP] === 'yes' && formData[groupElementMetaKey] !== undefined) {
            const fields = formElement[jsonKeyMapping.FORM_GROUP_ELEMENT]
            if (formData[groupElementMetaKey].dynamicIndex) {
                const allIndex = formData[groupElementMetaKey].dynamicIndex
                allIndex.forEach((index: number) => {
                    inputFieldGroup[`field-${index}`] = fields.map((field: TemplateObject) => {
                        return {
                            ...field,
                            [jsonKeyMapping.FORM_ID]: `${field[jsonKeyMapping.FORM_ID]}-${index}`
                        }
                    })
                })
            }
        }
        setInputFieldGroup(inputFieldGroup)
        /* max limit check */
        if (formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
            const dynamicFieldsListLength = Object.keys(inputFieldGroup).length
            if (dynamicFieldsListLength >= formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
                setMaxLimitReached(true)
            }
        }
        return () => { }
    }, [stepName, formElement])

    /* remove add fields Element */
    const removeInputField = (id: string) => {
        const inputFieldsKeys = Object.keys(inputFields)
        const startIndex = inputFieldsKeys.indexOf(id) + 1
        const updatedValues: TemplateObject = {}
        // eslint-disable-next-line no-unused-vars
        const [key, _index] = id.split(/(\d)/)
        /* rearrange the values  */
        for (let index = startIndex; index < inputFieldsKeys.length; index++) {
            updatedValues[inputFieldsKeys[index - 1]] = formData[`${key}${index}`]
        }
        /* update rearrange values */
        if (Object.keys(updatedValues).length > 0) {
            dispatch({ type: formActionEnum.SET_FORM_DATA, payload: updatedValues })
            /* delete the end value */
            const deletingIndex = inputFieldsKeys[inputFieldsKeys.length - 1]
            dispatch({ type: formActionEnum.REMOVE_FORM_DATA, payload: [deletingIndex] })
            setInputFields((state: TemplateObject) => {
                delete state[deletingIndex]
                return state
            })
        } else {
            /* Delete the previous set form data */
            dispatch({ type: formActionEnum.REMOVE_FORM_DATA, payload: [id] })
            setInputFields((state: TemplateObject) => {
                delete state[id]
                return state
            })
        }

        /* max limit check */
        if (formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
            setMaxLimitReached(false)
        }
    }
    /* add fields Element */
    const addFormElement = () => {
        /* set blank value for separator  */
        if (jsonKeyMapping.FORM_INPUT_SEPARATOR in formElement &&
            formElement[jsonKeyMapping.FORM_INPUT_SEPARATOR] !== null &&
            formData[formElement[jsonKeyMapping.FORM_ID]] === undefined
        ) {
            dispatch({ type: formActionEnum.SET_FORM_DATA, payload: { [formElement[jsonKeyMapping.FORM_ID]]: '' } })
        }

        /* max limit check */
        if (formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
            const dynamicFieldsListLength = Object.keys(inputFields).length
            if (dynamicFieldsListLength >= formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
                return false
            }
        }

        let elementIndex = 0
        Object.keys(inputFields).forEach((key) => {
            if (formData[`${formElement[jsonKeyMapping.FORM_ID]}${elementIndex}`] !== undefined) {
                elementIndex++
            }
        })
        const newID = `${formElement[jsonKeyMapping.FORM_ID]}${elementIndex}`
        const newElement = {
            [newID]: {
                ...formElement,
                [jsonKeyMapping.FORM_LABEL]: formElement[jsonKeyMapping.FORM_ADD_MORE_LABEL] || formElement[jsonKeyMapping.FORM_LABEL],
                [jsonKeyMapping.FORM_ID]: newID,
                [jsonKeyMapping.FORM_ADD_MORE]: false,
                isAddedDynamically: true,
                [jsonKeyMapping.FORM_SUB_TOOLTIP]: null,
                [jsonKeyMapping.FORM_INPUT_SEPARATOR]: null,
                [jsonKeyMapping.FORM_LABEL_SUB]: null,
                [jsonKeyMapping.FORM_SUBTEXT]: null,
                [jsonKeyMapping.STARTSWITH]: null,
                [jsonKeyMapping.ENDSWITH]: null,
                [jsonKeyMapping.ISBOTHFIELDNONEMPTY]: null,
                [jsonKeyMapping.INPUT_FIELD_SEPARATOR]: null,
                [jsonKeyMapping.PRE_FILL_INPUT_VAL]: null,
            }
        }
        /* Dynamic Field in formData */
        const formElementData: TemplateObject = {
            [newID]: ''
        }
        dispatch({ type: formActionEnum.SET_FORM_DATA, payload: formElementData })
        setInputFields((state) => ({ ...state, ...newElement }))
        /* max limit check */
        if (formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
            const dynamicFieldsListLength = Object.keys(inputFields).length + 1
            if (dynamicFieldsListLength === formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
                setMaxLimitReached(true)
            }
        }
    }

    /* Add group fields Elements */
    const addGroupFormElement = (fields: TemplateObject[]) => {
        /* set blank value for separator  */
        if (jsonKeyMapping.FORM_INPUT_SEPARATOR in formElement &&
            formElement[jsonKeyMapping.FORM_INPUT_SEPARATOR] !== null &&
            formData[formElement[jsonKeyMapping.FORM_ID]] === undefined
        ) {
            dispatch({ type: formActionEnum.SET_FORM_DATA, payload: { [formElement[jsonKeyMapping.FORM_ID]]: '' } })
        }
        /* max limit check */
        if (formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
            const dynamicFieldsListLength = Object.keys(inputFieldGroup).length
            if (dynamicFieldsListLength >= formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
                return false
            }
        }

        let elementIndex = 0
        /* Dynamic Field in formData */
        const formElementData: TemplateObject = {}
        /* TO KEEP TRACK OF ALL DYNAMIC ADD ELEMENTS */
        const groupElementMetaKey = `meta-data-${formElement[jsonKeyMapping.FORM_ID]}`
        if (formData[groupElementMetaKey] === undefined || formData[groupElementMetaKey].dynamicIndex === undefined) {
            formElementData[groupElementMetaKey] = { dynamicIndex: [elementIndex] }
        } else {
            const previousIndex = formData[groupElementMetaKey].dynamicIndex
            elementIndex = previousIndex[previousIndex.length - 1] + 1
            formElementData[groupElementMetaKey] = { dynamicIndex: [...previousIndex, elementIndex] }
        }

        const updateFields = fields.map((field: TemplateObject) => {
            if(field.calculation !== undefined){
                let calculateId = field.calculation.split("|")
                let modifiedId:any= [];
                calculateId.map((itemId: TemplateObject) => {
                    modifiedId.push(`${itemId}-${elementIndex}`)
                })
                return {
                    ...field,
                    [jsonKeyMapping.FORM_ID]: `${field[jsonKeyMapping.FORM_ID]}-${elementIndex}`,
                    [jsonKeyMapping.TOTAL_CALCULATION]: modifiedId.join("|"),
                    [jsonKeyMapping.SUB_TOTAL]: `${field[jsonKeyMapping.SUB_TOTAL]}-${elementIndex}`,
                }
            }else{
                return {
                    ...field,
                    [jsonKeyMapping.FORM_ID]: `${field[jsonKeyMapping.FORM_ID]}-${elementIndex}`
                }
            }
        })

        if (formData[groupElementMetaKey]) {
            formElementData[groupElementMetaKey] = { ...formData[groupElementMetaKey], ...formElementData[groupElementMetaKey] }
        }

        updateFields.forEach((field: TemplateObject) => (formElementData[field[jsonKeyMapping.FORM_ID]] = ''))
        setInputFieldGroup(val => ({ ...val, [`field-${elementIndex}`]: updateFields }))
        dispatch({ type: formActionEnum.SET_FORM_DATA, payload: formElementData })

        /* max limit check */
        if (formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
            const dynamicFieldsListLength = Object.keys(inputFieldGroup).length + 1
            if (dynamicFieldsListLength === formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
                setMaxLimitReached(true)
            }
        }
    }

    /* Remove group fields  Elements */
    const removeGroupFields = (key: string) => {
        const inputFieldsKeys = Object.keys(inputFieldGroup)
        const startIndex = inputFieldsKeys.indexOf(key) + 1
        const updatedValues: TemplateObject = {}
        // eslint-disable-next-line no-unused-vars
        const [id, _index] = key.split(/(\d)/)
        const ids: string[] = inputFieldGroup[key].map((field: TemplateObject) => {
            // eslint-disable-next-line no-unused-vars
            const [id, _index] = field[jsonKeyMapping.FORM_ID].split('-')
            return id
        })

        for (let index = startIndex; index < inputFieldsKeys.length; index++) {
            ids.forEach((id: string) => {
                updatedValues[`${id}-${index - 1}`] = formData[`${id}-${index}`]
            })
        }
        if (Object.keys(updatedValues).length > 0) {
            //dispatch({ type: formActionEnum.SET_FORM_DATA, payload: updatedValues })
            /* delete the end value */
            const deletingIndex = inputFieldsKeys[inputFieldsKeys.length - 1]
            const deleteIds: string[] = inputFieldGroup[key].map((field: TemplateObject) => {
                // eslint-disable-next-line no-unused-vars
                const [id, _index] = field[jsonKeyMapping.FORM_ID].split('-')
                return `${id}-${inputFieldsKeys.length - 1}`
            })

            const groupElementMetaKey = `meta-data-${formElement[jsonKeyMapping.FORM_ID]}`
            const dynamicIndex = formData[groupElementMetaKey].dynamicIndex
            const filterIndex = formData[groupElementMetaKey].dynamicIndex.filter((index: number) => (index !== dynamicIndex.length - 1))
            let formElementData: TemplateObject = {
                [groupElementMetaKey]: { dynamicIndex: filterIndex }
            }
            formElementData = {...formElementData, ...updatedValues}
            if (formData[groupElementMetaKey]) {
                formElementData[groupElementMetaKey] = { ...formData[groupElementMetaKey], ...formElementData[groupElementMetaKey] }
            } 
            removeStepKey(key,formElementData)
            //dispatch({ type: formActionEnum.SET_FORM_DATA, payload: formElementData })
            dispatch({ type: formActionEnum.REMOVE_FORM_DATA, payload: deleteIds })
            setInputFieldGroup(val => (produce(val, draft => {
                delete draft[deletingIndex]
            })))
        } else {
            const keys: string[] = []
            const fields = inputFieldGroup[key]
            fields.forEach((field: TemplateObject) => keys.push(field[jsonKeyMapping.FORM_ID]))
           
            const groupElementMetaKey = `meta-data-${formElement[jsonKeyMapping.FORM_ID]}`
            const dynamicIndex = formData[groupElementMetaKey].dynamicIndex
            const filterIndex = formData[groupElementMetaKey].dynamicIndex.filter((index: number) => (index !== dynamicIndex.length - 1))
            let formElementData: TemplateObject = {
                [groupElementMetaKey]: { dynamicIndex: filterIndex }
            }
            if (formData[groupElementMetaKey]) {
                formElementData[groupElementMetaKey] = { ...formData[groupElementMetaKey], ...formElementData[groupElementMetaKey] }
            } 
            if(formElementData[groupElementMetaKey].dynamicIndex.length === 0){
                delete formElementData[groupElementMetaKey].dynamicIndex
            }
            removeStepKey(key,formElementData)
            // eslint-disable-next-line no-unused-vars
            dispatch({ type: formActionEnum.REMOVE_FORM_DATA, payload: keys })
            setInputFieldGroup(val => (produce(val, draft => {
                delete draft[key]
            })))
        }
        /* max limit check */
        if (formElement[jsonKeyMapping.FORM_MAX_LIMIT]) {
            setMaxLimitReached(false)
        }
    }

    const removeStepKey = (field:any,formElementData:any) => {
        let allFormData = { ...formData }

        if(formElement.subTotal !== undefined){
            inputFieldGroup[field].forEach((elem: any) => {
                if (elem.id.split('-')[0] === `${formElement[jsonKeyMapping.FORM_ID]}`) {
                    const subtotalId=`subtotal${formElement[jsonKeyMapping.FORM_ID]}`
                let deletedTotalVal = formData[elem.id]
                let subTotalVal = formData[`subtotal${formElement[jsonKeyMapping.FORM_ID]}`]
                let finalVal = subTotalVal - deletedTotalVal
                    allFormData[subtotalId] = finalVal
                   
                    let removeKey =true
                    calculateListItem(formElementData,`${formElement[jsonKeyMapping.FORM_ID]}`,finalVal, formData, removeKey)
                    Object.keys(formElementData).forEach(function(id,i){
                        if(i > 0 ){
                            var val = formElementData[id];
                            allFormData[id] = val
                        }
                      });
                }
            })
        }
        allFormData= { ...allFormData, ...formElementData }
        dispatch({ type: formActionEnum.SET_FORM_DATA, payload: allFormData })
    }
    /* add more fields */
    const loadFields = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputText = e.target.value
        /* Valid if validation is provided */
        if (
            inputText !== '' &&
            formElement[jsonKeyMapping.FORM_VALIDATION_REGEX]
        ) {
            const regex = new RegExp(formElement[jsonKeyMapping.FORM_VALIDATION_REGEX], 'g')
            if (!inputText.match(regex)) return false
        }
        let startsWith =""
        let isBothFieldNonEmpty = []
        let startsWithKey = ""
        let inputFieldSeparator = ""
        let prefillInputVal = formElement[jsonKeyMapping.PRE_FILL_INPUT_VAL] || ''
        if (formElement[jsonKeyMapping.STARTSWITH] !== undefined) {
            startsWith = e.target.value !== '' ? formElement[jsonKeyMapping.STARTSWITH] : ""
            inputFieldSeparator = e.target.value !== '' ? formElement[jsonKeyMapping.INPUT_FIELD_SEPARATOR] : ""
            startsWithKey = formElement[jsonKeyMapping.FORM_ID]
            isBothFieldNonEmpty = formElement[jsonKeyMapping.ISBOTHFIELDNONEMPTY] || ''
            if(isBothFieldNonEmpty !== ''){
                let frstFieldId =isBothFieldNonEmpty.split("|")[0]
                let scndFieldId =isBothFieldNonEmpty.split("|")[1]
                startsWithKey = frstFieldId
                let frstVal=''
                let scndVal=''
                if (formElement[jsonKeyMapping.FORM_ID] === frstFieldId) {
                    frstVal=e.target.value
                    scndVal= !!formData[scndFieldId] ? scndFieldId : ''
                }
                else if (formElement[jsonKeyMapping.FORM_ID] === scndFieldId) {
                    scndVal=e.target.value
                    frstVal= !!formData[frstFieldId] ? frstFieldId : ''
                }
               if(frstVal !== '' && scndVal !== ''){
                inputFieldSeparator = formElement[jsonKeyMapping.INPUT_FIELD_SEPARATOR]
               }
               else{
                inputFieldSeparator = ""
               }
               if(frstVal === '' && scndVal === ''){
                startsWith = ""
               }else{
                startsWith = formElement[jsonKeyMapping.STARTSWITH]
               }
            }
        }
        if (e.target.value !== '' && formElement[jsonKeyMapping.FORM_INPUT_RADIO_MORE_FIELDS] !== undefined) {
            setConditionalInput({
                formElement: formElement[jsonKeyMapping.FORM_INPUT_RADIO_MORE_FIELDS],
                parentLabel: formElement[jsonKeyMapping.FORM_LABEL],
                value: formElement[jsonKeyMapping.FORM_VALUE]
            })
        } else {
            setConditionalInput(null)
        }
        let event:any = e
        handleInputChange(event,startsWith,startsWithKey,inputFieldSeparator,prefillInputVal)
    }
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (datePickerRef.current && !datePickerRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const loadDateFields = (item: any) => {
        let date = item.value;
        // let name = item.name;
        let id = item.id;
        setConditionalInput(null);
        const formattedDate = date ? moment(date).format("MM-DD-YYYY") : null;
        setOpen(false)
        handleDateChange(id, "date", formattedDate);
    };
    return (
        <InputWrapper
            formElement={formElement}
            label={formElement[jsonKeyMapping.FORM_LABEL] || ''}
            labelsub={formElement[jsonKeyMapping.FORM_LABEL_SUB] || ''}
            subtext={formElement[jsonKeyMapping.FORM_SUBTEXT] || ''}
        >
            {(formElement[jsonKeyMapping.FORM_PREFIX_SYMBOL] || formElement[jsonKeyMapping.FORM_SUFFIX_SYMBOL])
                ? (<InputTextMask
                    formElement={formElement}
                    handleInputChange={loadFields}
                />)
                : (formElement?.inputType && formElement?.inputType === 'date' ? <>

                    <div style={{ position: 'relative' }} ref={datePickerRef}>
                        <DatePicker
                            //                     selected={selectedDate}
                            onChange={(date) => loadDateFields({ name: formElement.name, id: formElement[jsonKeyMapping.FORM_ID], value: date })}
                            open={open}
                            dateFormat={formElement[jsonKeyMapping.FORM_DATE_FORMAT]}
                            minDate={formElement.min ? new Date(formElement.min) : null}
                            maxDate={formElement.max ? new Date(formElement.max) : null}
                            className={`form-control ${formElement.inputClass ? formElement.inputClass : ''
                                }`}
                            id={formElement[jsonKeyMapping.FORM_ID]}
                            value={formData[formElement[jsonKeyMapping.FORM_ID]] ? formData[formElement[jsonKeyMapping.FORM_ID]] : ''}
                            onInputClick={() => setOpen((prev) => !prev)}
                            placeholderText={formElement[jsonKeyMapping.FORM_PLACEHOLDER] || ''}
                            peekNextMonth={true}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            dropdownMode="select"
                        />
                        <img
                            src={process.env.PUBLIC_URL + "/static/images/calendar-icon.svg"}
                            alt="calendar"
                            style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', width: 20 }}
                            onClick={() => setOpen((prev) => !prev)}
                        />
                    </div>
                </> : <input
                    id={formElement[jsonKeyMapping.FORM_ID]}
                    className={`form-control ${formElement.inputClass ? formElement.inputClass : ''
                        }`}
                    placeholder={formElement[jsonKeyMapping.FORM_PLACEHOLDER] || ''}
                    type={formElement.type}
                    onChange={loadFields}
                    onBlur={(e) => {
                        const label = formElement[jsonKeyMapping.FORM_LABEL] || ''
                        onBlur(e, label, formElement)
                    }}
                    maxLength={formElement.maxLength || formElement[jsonKeyMapping.FORM_MAX_LENGTH] || null}
                    value={formData[formElement[jsonKeyMapping.FORM_ID]] ? formData[formElement[jsonKeyMapping.FORM_ID]] : ''}
                />)}
            {/* ADD MORE Fields */}
            {
                formElement[jsonKeyMapping.FORM_ADD_MORE_GROUP_LABEL]
                    ? (<AddMoreGroupElements formElement={formElement} inputFields={inputFields} removeInputField={removeInputField} />)
                    : (<AddMoreElements inputFields={inputFields} removeInputField={removeInputField} />)
            }
            {/* ADD More Action Btn */}
            {(formElement[jsonKeyMapping.FORM_ADD_MORE] && isMaxLimitReached === false) &&
                <span className="mt-2 btn-blue add-button  add-more-btn" onClick={addFormElement}><i className="fa fa-plus" aria-hidden="true"></i> Add More</span>
            }
            {/* Load the group Element */}
            {<GroupElements inputFieldGroup={inputFieldGroup} removeGroupFields={removeGroupFields} formElement={formElement} groups={groups} />}
            {(formElement[jsonKeyMapping.FORM_ADD_MORE_GROUP] && isMaxLimitReached === false) && <>
                <span className="mt-2 add-more-btn blue-color" onClick={() => addGroupFormElement(formElement[jsonKeyMapping.FORM_GROUP_ELEMENT])}><i className="fa fa-plus" aria-hidden="true"></i> Add More</span>
            </>

            }
        </InputWrapper>

    )
}

export default InputText
